import { Modal, Button } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";


const ImportStatusModal = (props) => {
    return (
        <Modal
            open={props?.open}
            onClose={() => props?.onClose()}
            sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        >
            <Box sx={{ display: "flex", flexDirection: "column", width: { xs: "90%",sm:"90%", md: "392px" ,lg:"392px"}, justifyContent: "center", alignItems: "center", padding: 4, backgroundColor: 'white', borderRadius: "12px" }}>
                <img src={props?.icon} />
                <Box sx={{ fontSize: "16px",font:"Montserrat", fontWeight:500, color: "#191E31", textAlign: "center", marginTop: "10px", marginBottom: "10px" }} variant="h8">
                    {props?.message}
                </Box>
                <Box sx={{ display: "flex", gap: 2 }}>
                    <Button
                        sx={{
                            borderRadius: "10px",
                            minWidth: 94,
                            minHeight: 42.05,
                            background: "#EF7D00",
                            marginTop: "13px",
                            "&:hover": {
                                backgroundColor: "#EF7D00",
                            },
                        }}
                        variant="contained"
                        type="button"
                        onClick={() => props?.onClose()}
                    >OK
                    </Button>
                </Box>

            </Box>
        </Modal>
    )
}

export default ImportStatusModal;
